// mds-dojo — dijit/ToolbarSeparator — FAITHFUL port of references/dijit/ToolbarSeparator.js.
// A spacer between two dijit/Toolbar items. declare from the faithful runtime.
import declare from '../dojo/_base/declare-runtime'; // declare
import dom from '../dojo/dom'; // dom.setSelectable
import _Widget from './_Widget';
import _TemplatedMixin from './_TemplatedMixin';

export default declare('dijit.ToolbarSeparator', [_Widget, _TemplatedMixin], {
  // summary:
  //		A spacer between two `dijit.Toolbar` items

  templateString: '<div class="dijitToolbarSeparator dijitInline" role="presentation"></div>',

  buildRendering: function () {
    this.inherited(arguments);
    dom.setSelectable(this.domNode, false);
  },

  isFocusable: function () {
    // This widget isn't focusable, so pass along that fact.
    return false;
  },
});
